import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledContactInformationDiv = styled.div`
  ${rtl`
  .contactInformation {
    @media ${theme.mediaQuery.tabletMax} {
      justify-content: center;
      .m-input-field {
        margin-bottom: ${toRem(32)};
      }
      .checkbox {
        padding-right: ${toRem(80)};
      }
    }
    @media ${theme.mediaQuery.mobileOnly} {
      .m-input-field {
        margin-bottom: ${toRem(22)};
        &:last-child {
          margin-bottom: ${toRem(0)};
        }
      }
      .checkbox {
        padding-right: ${toRem(16)};
      }
  }
  }
  .textAreaInput {
    height: ${toRem(200)};
  }
`}
`;
